import React, { useContext, useEffect, useState } from "react";

import Collapsible from "react-collapsible";
import { fetchUsersList } from "../../api/usersApi";
import { LoginContext } from "../../context/loginContext";
import DoorStyles from "../../data/doorStyles.json";
import { Button } from "../ui";
import "./Admin.css";

const Admin = () => {
  const { action, authenticatedUser, currentUser } = useContext(LoginContext);
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(true);
  const [usersError, setUsersError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!authenticatedUser) {
      setUsers([]);
      setUsersLoading(false);
      setUsersError(null);
      return undefined;
    }
    (async () => {
      setUsersLoading(true);
      setUsersError(null);
      try {
        const list = await fetchUsersList(authenticatedUser);
        if (!cancelled) {
          setUsers(list);
        }
      } catch (e) {
        if (!cancelled) {
          const msg =
            e?.response?.data?.message ||
            e?.response?.data?.error ||
            e?.message ||
            "Could not load users.";
          setUsersError(typeof msg === "string" ? msg : "Could not load users.");
          setUsers([]);
        }
      } finally {
        if (!cancelled) setUsersLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authenticatedUser]);
  // Add option to add door styles
  /*   
  const [newStyle, setNewStyle] = useState({
    brand: "",
    style: "",
    description: "",
  });
  const [doorStyleInput, setDoorStyleInput] = useState(false);

  const updateDoorStyle = (event) => {
    event.preventDefault();

    const { name, value } = event.target;

    setNewStyle({
      ...newStyle,
      [name]: value,
    });
  };

  const addDoorStyle = (event) => {
    event.preventDefault();

    setDoorStyleInput(true);
  };

  const cancelDoorStyle = (event) => {
    event.preventDefault();

    setNewStyle({
      brand: "",
      style: "",
      description: "",
    });

    setDoorStyleInput(false);
  };

  const submitDoorStyle = (event) => {
    event.preventDefault();
    console.log(typeof DoorStyles);
    DoorStyles.push(newStyle);
  }; */

  return (
    <div className="Admin">
      <div className="Admin-container">
        {currentUser && (
          <div className="Admin-header">
            <h4 className="title">Current User: {currentUser.username}</h4>
            <span>
              <Button
                type="button"
                variant="primary"
                onClick={() => action.signOut()}
                leadingIcon={<i className="fas fa-sign-out-alt" aria-hidden="true" />}
              >
                Logout
              </Button>
            </span>
          </div>
        )}
        <div
          style={{
            marginTop: "5rem",
            width: "100%",
            height: "2px",
            marginBottom: "1rem",
            border: "1px solid rgb(84, 163, 202)",
            backgroundColor: "rgb(84, 163, 202)",
          }}
        ></div>

        <Collapsible
          className="collapsible-section"
          trigger="Users"
          open={true}
        >
          {usersError && (
            <p className="mb-2 text-sm text-red-600" role="alert">
              {usersError}
            </p>
          )}
          {usersLoading && <p className="mb-2 text-sm text-ink-500">Loading users…</p>}
          {!usersLoading && !usersError && users.length === 0 && (
            <p className="mb-2 text-sm text-ink-500">No users returned from the server.</p>
          )}
          <table className="Admin-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Username</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={user._id || user.username || user.email || index}>
                  <td>{index + 1}</td>
                  <td>{user.username || "—"}</td>
                  <td>{user.email || user.emailAddress || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <Button type="button" variant="primary" size="sm" className="mt-3">
            Add
          </Button>

          {/* Add option to add doorstyles later */}
          {/* {doorStyleInput ? (
            <div className="Admin-button-container">
              <button
                className="btn btn-outline-danger"
                onClick={cancelDoorStyle}
              >
                Cancel
              </button>
              <button className="btn btn-success" onClick={submitDoorStyle}>
                Submit
              </button>
            </div>
          ) : (
            <button className="btn Admin-btn" onClick={addDoorStyle}>
              Add
            </button>
          )} */}
        </Collapsible>

        <Collapsible
          className="collapsible-section"
          trigger="Door Styles"
          open={false}
        >
          <table className="Admin-table">
            <tr>
              <th></th>
              <th>Brand</th>
              <th>Style</th>
              <th>Description</th>
            </tr>
            {DoorStyles.map((doorStyle, index) => {
              return (
                <tr>
                  <td>{index + 1}</td>
                  <td>
                    {" "}
                    <tr className="Admin-input-field">{doorStyle.brand}</tr>
                  </td>
                  <td>
                    {" "}
                    <tr className="Admin-input-field">{doorStyle.style}</tr>
                  </td>
                  <td>
                    {" "}
                    <tr className="Admin-input-field">
                      {doorStyle.description}
                    </tr>
                  </td>
                  {/* <td>
                    <i className="Admin-delete fas fa-minus-circle"></i>
                  </td> */}
                </tr>
              );
            })}
          </table>

          {/* Add option to add doorstyles later */}
          {/* {doorStyleInput ? (
            <div className="Admin-button-container">
              <button
                className="btn btn-outline-danger"
                onClick={cancelDoorStyle}
              >
                Cancel
              </button>
              <button className="btn btn-success" onClick={submitDoorStyle}>
                Submit
              </button>
            </div>
          ) : (
            <button className="btn Admin-btn" onClick={addDoorStyle}>
              Add
            </button>
          )} */}
        </Collapsible>
      </div>
    </div>
  );
};

export default Admin;
